import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n' // Initialize i18n
import { initializeModules } from './modules/configs' // Initialize module registry
import App from './App.tsx'

// Register all modules before app renders
initializeModules();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
